import geofence from 'assets/icons/kinesis/geofence.svg';
import geofenceAdd from 'assets/icons/kinesis/geofence-add.svg';
import geofenceEdit from 'assets/icons/kinesis/geofence-edit.svg';
import videoAdd from 'assets/icons/kinesis/video-add.svg';

/**
 * Custom artwork a theme can substitute in place of a glyph, keyed by the name the theme uses
 * (`svg:geofence`). See assets/icons/kinesis/README.md for what a file has to look like.
 *
 * This sits apart from icons.ts, and out of the barrel, because the karma builder has no way to
 * read .svg as text — anything a spec can reach must not import one. main.ts hands this to
 * setSvgIcons() at startup.
 */
export const SVG_ICONS = {
    'geofence': geofence,
    'geofence-add': geofenceAdd,
    'geofence-edit': geofenceEdit,
    'video-add': videoAdd,
};
